import React from 'react';
import themeStyles from './StaticNumberChart.styles';
import StaticNumberChartUi from './StaticNumberChartUi';
var StaticNumberChart = function (_a) {
    var fields = _a.fields;
    if (!fields) {
        return null;
    }
    var chartItemTitle = fields.chartItemTitle, chartItemValue = fields.chartItemValue, chartItemBodyText = fields.chartItemBodyText;
    var GraphicContainer = themeStyles.apply('div', 'GraphicContainer');
    return (React.createElement(GraphicContainer, null,
        React.createElement(StaticNumberChartUi, { chartValue: "".concat(chartItemValue === null || chartItemValue === void 0 ? void 0 : chartItemValue.value, "+"), chartTitle: chartItemTitle === null || chartItemTitle === void 0 ? void 0 : chartItemTitle.value, chartBodyText: chartItemBodyText === null || chartItemBodyText === void 0 ? void 0 : chartItemBodyText.value })));
};
export default StaticNumberChart;
